import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import VersionUpdated from '@Shared/Components/VersionUpdated';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { createInertiaApp } from '@inertiajs/react';
import BlankLayout from '@Web/Pages/Layout';
import { initSentry } from '@Web/sentry';

import '../css/app.scss';
import '../css/reset.css';
import './bootstrap';

globalThis.resolveMomentumModal = async (name) => {
    const modals = import.meta.glob('./Pages/**/Modals/**/*.jsx');
    return await modals[`./Pages/${name}/index.jsx`]();
};

createInertiaApp({
    resolve: async (name) => {
        try {
            const isMobile =
                window.device === 'mobile' &&
                Object.keys(import.meta.glob('./Pages/**/*.jsx')).includes(
                    `./Pages/${name}/index.mobile.jsx`
                );
            const page = await resolvePageComponent(
                `./Pages/${name}/${isMobile ? 'index.mobile' : 'index'}.jsx`,
                import.meta.glob('./Pages/**/*.jsx')
            );
            page.default.layout =
                page.default.layout || ((page) => <BlankLayout>{page}</BlankLayout>);
            return page;
        } catch (err) {
            console.warn(err);
            return {
                default: VersionUpdated,
            };
        }
    },
    setup({ el, App, props }) {
        if (import.meta.env.SSR) {
            hydrateRoot(el, <App {...props} />);
            return;
        }

        if (import.meta.env.VITE_SENTRY_DSN) {
            initSentry();
        }

        createRoot(el).render(<App {...props} />);
    },
    progress: {
        color: '#4B5563',
    },
});
